import { ModalV2 } from "@jsq/ds/core";
import { Form, FormTextInput, SubmitButton, CancelButton } from "@jsq/ds/forms";
import { FormValues } from "./hooks";
import { validationSchema } from "./schema";
import { footerStyles } from "./styles_vanilla.css";

type EditAccountSettingsModalProps = {
  show: boolean;
  onHide: () => void;
  initialValues: FormValues;
  onSubmit: (values: Partial<FormValues>) => Promise<void>;
  isSubmitting: boolean;
};

export const EditAccountSettingsModal = ({
  show,
  onHide,
  initialValues,
  onSubmit,
  isSubmitting,
}: EditAccountSettingsModalProps) => {
  return (
    <ModalV2
      show={show}
      onHide={onHide}
      title="Edit account settings"
      data-testid="edit-account-settings-modal"
    >
      <Form
        initialValues={initialValues}
        yupValidationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <ModalV2.Body>
          <FormTextInput
            name="emailAddress"
            label="Email address"
            placeholder="Enter email address"
            type="email"
            disabled={isSubmitting}
            isFullWidth
          />
        </ModalV2.Body>

        <ModalV2.Footer className={footerStyles}>
          <CancelButton onClick={onHide} disabled={isSubmitting}>
            Cancel
          </CancelButton>
          <SubmitButton
            isLoading={isSubmitting}
            data-testid="save-account-settings-button"
            disabled={isSubmitting}
          >
            Save
          </SubmitButton>
        </ModalV2.Footer>
      </Form>
    </ModalV2>
  );
};
